import { computed as g, createBlock as o, openBlock as l, normalizeProps as f, guardReactiveProps as h, withCtx as w, createElementVNode as s, renderSlot as d, normalizeClass as n, createElementBlock as r, createCommentVNode as i, toDisplayString as c } from "vue";
import y from "../../../atoms/eyebrow/eyebrow.vue.js";
import { themeProp as k } from "../../../composables/useTheme.js";
import S from "../../../molecules/link/link.vue.js";
import { sectionProps as b } from "../mixins/useSectionProps.js";
import p from "../section-single/section-single.vue.js";
import x from "../../../utils/validators/link.js";
const v = ["textContent"], B = ["textContent"], u = "DsSectionGroup", N = /* @__PURE__ */ Object.assign({
  name: u
}, {
  __name: "section-group",
  props: {
    ...k,
    ...b,
    /**
     * Section Title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Section Subtitle
     */
    subtitle: {
      type: String,
      default: ""
    },
    /**
     * Section Link
     */
    link: {
      type: Object,
      default: null,
      validator: (e) => x(e)
    },
    /**
     * Section Eyebrow
     */
    eyebrow: {
      type: String,
      default: ""
    },
    /**
     * Center content
     */
    centered: {
      type: Boolean,
      default: !1
    },
    /**
     * Enlarge Title
     */
    withTitleSizeLarge: {
      type: Boolean,
      default: !1
    },
    withoutTextPadding: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, m = g(() => a.eyebrow || a.title || a.subtitle || a.link);
    return (t, z) => (l(), o(p, f(h({ withSpace: t.withSpace, withSpaceTop: t.withSpaceTop, withSpaceBottom: t.withSpaceBottom, spaceOptionsSmall: t.spaceOptionsSmall, spaceOptionsMedium: t.spaceOptionsMedium, fullScreen: t.fullScreen, theme: t.theme })), {
      default: w(() => [
        s("div", {
          class: n({ "ds-container": t.fullScreen })
        }, [
          m.value ? (l(), r("div", {
            key: 0,
            class: n(["ds-grid", {
              "ds-justify-content-center": e.centered
            }])
          }, [
            s("div", {
              class: n(["ds-grid__col ds-md-grid__col--8 ds-grid__col--12 ds-lg-grid__col--8 ds-margin-bottom-48", { "ds-padding-left-0": e.withoutTextPadding }])
            }, [
              e.eyebrow ? (l(), o(y, {
                key: 0,
                text: e.eyebrow,
                theme: t.theme,
                class: n(["ds-margin-bottom-24", {
                  "ds-text-align-center": e.centered
                }])
              }, null, 8, ["text", "theme", "class"])) : i("", !0),
              d(t.$slots, "title", {}, () => [
                e.title ? (l(), r("h2", {
                  key: 0,
                  class: n(["ds-heading", {
                    "ds-margin-bottom-12": e.subtitle,
                    "ds-text-align-center": e.centered,
                    "ds-heading-large": e.withTitleSizeLarge
                  }]),
                  "data-j-title": "",
                  textContent: c(e.title)
                }, null, 10, v)) : i("", !0)
              ]),
              d(t.$slots, "subtitle", {}, () => [
                e.subtitle ? (l(), r("p", {
                  key: 0,
                  class: n(["ds-text", { "ds-text-align-center": e.centered }]),
                  "data-j-subtitle": "",
                  textContent: c(e.subtitle)
                }, null, 10, B)) : i("", !0)
              ]),
              e.link ? (l(), o(S, {
                key: 1,
                "tracking-data": { "component-name": u, text: e.link.text, title: e.title },
                url: e.link.url,
                "lazy-url-endpoint": e.link.lazyUrlEndpoint,
                content: e.link.text,
                nuxt: e.link.nuxt,
                "open-in-new-window": e.link.openInNewWindow,
                "icon-right": { name: "chevron-right-small", category: "arrows" },
                class: n(["ds-margin-top-24", { "ds-display-flex ds-justify-content-center": e.centered }])
              }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "content", "nuxt", "open-in-new-window", "class"])) : i("", !0)
            ], 2)
          ], 2)) : i("", !0)
        ], 2),
        d(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  N as default
};
